import { render } from "./PageArchive.vue?vue&type=template&id=9ceeb5e8"
import script from "./PageArchive.vue?vue&type=script&lang=js"
export * from "./PageArchive.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__